import axios from 'axios';
import API_BASE_URL from './api';

const API = `${API_BASE_URL}/api`;

const authHeaders = (token) => (token ? { Authorization: `Bearer ${token}` } : {});

// Public fetchers
export const fetchSiteSettings = async () => {
  const res = await axios.get(`${API}/site/settings`, { withCredentials: true });
  return res.data;
};

export const fetchNavigation = async () => {
  const res = await axios.get(`${API}/site/navigation`, { withCredentials: true });
  return res.data;
};

export const fetchPublicAnnouncements = async () => {
  const res = await axios.get(`${API}/site/announcements`);
  return res.data; // { announcements: [...] }
};

export const fetchPublicMaintenance = async () => {
  // Timeout court: la vérification de maintenance ne doit jamais bloquer le rendu du site.
  const res = await axios.get(`${API}/site/maintenance`, { timeout: 8000 });
  return res.data; // { enabled, message }
};

// Admin (founder) actions
export const fetchOrgStats = async (token) => {
  const res = await axios.get(`${API}/admin/org-stats`, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data; // { members, years, countries: [...] }
};

export const saveOrgStats = async (payload, token) => {
  const res = await axios.post(`${API}/admin/org-stats`, payload, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};

export const saveSiteSettings = async (payload, token) => {
  const res = await axios.post(`${API}/admin/site/settings`, payload, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};

export const saveNavigation = async (items, token) => {
  const res = await axios.post(`${API}/admin/site/navigation`, { items }, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};

// Announcements Admin
export const adminListAnnouncements = async (token) => {
  const res = await axios.get(`${API}/admin/site/announcements`, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};

export const adminCreateAnnouncement = async (payload, token) => {
  const res = await axios.post(`${API}/admin/site/announcements`, payload, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};

export const adminUpdateAnnouncement = async (id, payload, token) => {
  const res = await axios.put(`${API}/admin/site/announcements/${id}`, payload, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};

export const adminDeleteAnnouncement = async (id, token) => {
  const res = await axios.delete(`${API}/admin/site/announcements/${id}`, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};

// Maintenance Admin
export const adminGetMaintenance = async (token) => {
  const res = await axios.get(`${API}/admin/site/maintenance`, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};

export const adminSaveMaintenance = async (payload, token) => {
  const res = await axios.post(`${API}/admin/site/maintenance`, payload, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};

// Security Admin (2FA + founders whitelist)
export const adminGetSecurity = async (token) => {
  const res = await axios.get(`${API}/admin/security/settings`, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data; // { two_fa_enabled, allowed_founders: [] }
};

export const adminSaveSecurity = async (payload, token) => {
  const res = await axios.post(`${API}/admin/security/settings`, payload, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};

// Payment settings Admin
export const fetchPaymentSettings = async (token) => {
  const res = await axios.get(`${API}/admin/payment-settings`, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};

export const savePaymentSettings = async (payload, token) => {
  const res = await axios.post(`${API}/admin/payment-settings`, payload, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};

// Section "Explorer PADAID" (bento accueil)
export const fetchBentoAdmin = async (token) => {
  const res = await axios.get(`${API}/admin/bento`, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};

export const saveBento = async (payload, token) => {
  const res = await axios.post(`${API}/admin/bento`, payload, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};

// Fonds photo par page (jour / nuit + intensité)
export const fetchBackgroundsPublic = async (scope = 'default') => {
  const res = await axios.get(`${API}/site/backgrounds`, { params: { scope } });
  return res.data;
};

export const fetchBackgroundsAll = async (token) => {
  const res = await axios.get(`${API}/admin/backgrounds`, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data; // { scopes, defaults, scope_keys }
};

export const saveBackgroundScope = async (scope, config, token) => {
  const res = await axios.post(`${API}/admin/backgrounds`, { scope, config }, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};

// Bibliothèque de fonds dédiée (pool tiré aléatoirement)
export const fetchBgLibraryPublic = async () => {
  const res = await axios.get(`${API}/site/bg-library`);
  return res.data; // { light:[], dark:[], interval }
};

export const fetchBgLibraryAdmin = async (token) => {
  const res = await axios.get(`${API}/admin/bg-library`, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};

export const saveBgLibrary = async (payload, token) => {
  const res = await axios.post(`${API}/admin/bg-library`, payload, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data;
};